export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/web/app/themes/main-theme/resources/assets/scripts/routes/home.js